import { categories, sites, topics } from '@/mocks/navData';
import type { Category, Site, Topic } from '@/types/nav';

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((item) => item.slug === slug);
}

export function getSitesByCategory(slug: string): Site[] {
  return sites.filter((site) => site.category === slug);
}

export function getSiteById(id: string): Site | undefined {
  return sites.find((site) => site.id === id);
}

export function getTopicById(id: string): Topic | undefined {
  return topics.find((topic) => topic.id === id);
}

export function getSitesByIds(ids: string[]): Site[] {
  return ids
    .map((id) => getSiteById(id))
    .filter((site): site is Site => Boolean(site));
}

export function getHotSites(limit = 8): Site[] {
  return [...sites].sort((a, b) => b.hot - a.hot).slice(0, limit);
}

export function getLatestSites(limit = 8): Site[] {
  return [...sites]
    .sort((a, b) => (a.addedAt < b.addedAt ? 1 : -1))
    .slice(0, limit);
}

export function getFeaturedSites(limit = 6): Site[] {
  const featured = sites.filter((site) => site.featured);
  return featured.slice(0, limit);
}

export function getRelatedSites(site: Site, limit = 4): Site[] {
  const sameCategory = sites.filter(
    (item) => item.category === site.category && item.id !== site.id,
  );
  const sameSub = sameCategory.filter(
    (item) => item.subCategory === site.subCategory,
  );
  const others = sameCategory.filter(
    (item) => item.subCategory !== site.subCategory,
  );
  return [...sameSub, ...others].slice(0, limit);
}

export function searchSites(keyword: string): Site[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return sites.filter((site) => {
    const haystack = [
      site.name,
      site.description,
      site.subCategory,
      site.region,
      ...site.tags,
    ]
      .join(' ')
      .toLowerCase();
    return haystack.includes(key);
  });
}

export function getCountByCategory(slug: string): number {
  return sites.filter((site) => site.category === slug).length;
}